<template>
  <topHeader />
  <div class="land-supply-page">
      <div class="container">
        
      <!-- 搜索栏 -->
      <!-- <div class="search-section">
        <div class="search-bar">
          <input 
            type="text" 
            v-model="searchKeyword" 
            placeholder="搜索关键字" 
            class="search-input"
            @keyup.enter="performSearch"
          />
            <button class="search-btn" @click="performSearch">搜索</button>
            <button class="map-btn" @click="showMapModal">地图找地</button>
        </div>
      </div> -->

      <!-- 筛选栏 -->
      <div class="filter-section">
        <div class="horizontal-filter-group">
          <!-- 筛选标签行 -->
          <div class="filter-labels-row">
 
            <div class="filter-select-group">
              <label class="filter-select-label">排序</label>
              <div 
                class="filter-select-wrapper"
                @click.stop="toggleDropdown('filter')"
                @mouseleave="hideDropdown('filter')"
              >
                <div class="filter-select-input">
                  <span class="filter-select-value">{{ getFilterLabel(selectedFilter) }}</span>
                  <span class="iconfont icon-xiangyou3 filter-arrow"></span>
                </div>
                <div 
                  class="filter-dropdown" 
                  v-show="showFilterDropdown"
                >
                  <span 
                    v-for="filter in filterOptions" 
                    :key="filter.value"
                    :class="['filter-option', { active: selectedFilter === filter.value }]"
                    @click.stop="handleFilterChange(filter.value)"
                  >
                    {{ filter.label }}
                  </span>
                </div>
              </div>
            </div>

            <div class="filter-select-group">
              <label class="filter-select-label">土方类型</label>
              <div 
                class="filter-select-wrapper"
                @click.stop="toggleDropdown('type')"
                @mouseleave="hideDropdown('type')"
              >
                <div class="filter-select-input">
                  <span class="filter-select-value">{{ getTypeLabel(selectedType) }}</span>
                  <span class="iconfont icon-xiangyou3 filter-arrow"></span>
                </div>
                <div 
                  class="filter-dropdown" 
                  v-show="showTypeDropdown"
                >
                  <span 
                    :class="['filter-option', { active: selectedType === '' }]"
                    @click.stop="handleTypeChange('')"
                  >
                    全部
                  </span>
                  <span 
                    v-for="type in typeOptions" 
                    :key="type.value"
                    :class="['filter-option', { active: selectedType === type.value }]"
                    @click.stop="handleTypeChange(type.value)"
                  >
                    {{ type.label }}
                  </span>
                </div>
              </div>
            </div>
            
            <div class="filter-select-group">
              <label class="filter-select-label">区域</label>
              <div 
                class="filter-select-wrapper"
                @click.stop="toggleDropdown('region')"
                @mouseleave="hideDropdown('region')"
              >
                <div class="filter-select-input">
                  <span class="filter-select-value">{{ getRegionLabel(selectedRegion) }}</span>
                  <span class="iconfont icon-xiangyou3 filter-arrow"></span>
                </div>
                <div 
                  class="filter-dropdown" 
                  v-show="showRegionDropdown"
                >
                  <span 
                    :class="['filter-option', { active: selectedRegion === '' }]"
                    @click.stop="handleRegionChange('')"
                  >
                    全部
                  </span>
                  <span 
                    v-for="region in regionOptions" 
                    :key="region.value"
                    :class="['filter-option', { active: selectedRegion === region.value }]"
                    @click.stop="handleRegionChange(region.value)"
                  >
                    {{ region.label }}
                  </span>
                </div>
              </div>
            </div>
            
          </div>
          <div class="search-bar">
              <button class="search-btn" @click="performSearch">搜索</button>
              <button class="map-btn" @click="showMapModal">地图找地</button>
              <button class="map-btn" @click="showPublishModal">没有我想要的，发布需求</button>
        </div>
        </div>
      </div>

      <!-- 土列表 -->
      <div class="land-list">
        <div class="land-item" v-for="(land, index) in landList" :key="index" @click="goToLandDetail(land.id)">
          <div class="land-image">
            <img :src="land.image" :alt="land.title" class="land-thumbnail">
            <div class="guarantee-badge">{{land.region}}</div>
           
            <div v-if="land.isVideo" class="play-button">
              <span class="iconfont icon-play"></span>
            </div>
          </div>
          <div class="land-details">
            <h3 class="land-title">{{ land.title }}</h3>
            <div class="land-tags">
              <span class="tag" v-for="tag in land.tags" :key="tag">{{ tag }}</span>
            </div>
            <p class="land-description">{{ land.description }}</p>
            <!-- <div class="land-price">{{ land.price }}</div> -->
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination" v-if="landList.length > 0">
        <button class="page-btn" :disabled="pageNum === 1" @click="prevPage">上一页</button>
        <span class="page-info">{{ pageNum }} / {{ totalPages || 1 }}</span>
        <button class="page-btn" :disabled="pageNum === totalPages" @click="nextPage">下一页</button>
      </div>
    </div>

    <!-- 地图模态框 -->
    <div v-if="showMap" class="map-modal" @click="closeMapModal">
      <div class="map-container" @click.stop>
        <div class="map-header">
          <h3>地图找地</h3>
          <button class="close-btn" @click="closeMapModal">×</button>
        </div>
        
        <div class="map-controls">
          <div class="location-input">
            <input 
              type="text" 
              v-model="mapLocation" 
              placeholder="请输入地址或点击地图定位"
              class="location-search"
            />
            <button class="search-location-btn" @click="searchLocation">搜索</button>
          </div>
          
          <div class="distance-selector">
            <label>搜索范围：</label>
            <select v-model="selectedDistance" @change="updateMapRadius">
              
              <option value="5">5公里</option>
              <option value="10">10公里</option>
              <option value="20">20公里</option>
            </select>
          </div>
        </div>
        
        <div class="map-content">
          <div id="amap-container" class="amap-container"></div>
          <div class="map-tip">点击地图选择位置，系统将搜索{{ selectedDistance }}公里范围内的土</div>
        </div>
        
        <div class="map-results" v-if="mapResults.length > 0">
          <h4>附近土 ({{ mapResults.length }}个)</h4>
          <div class="results-list">
            <div 
              class="result-item" 
              v-for="(result, index) in mapResults" 
              :key="index"
              @click="selectMapResult(result)"
            >
              <div class="result-info">
                <h5>{{ result.title }}</h5>
                <p>{{ result.description }}</p>
                <span class="distance">距离: {{ result.distance }}km</span>
              </div>
              <div class="result-price">{{ result.price }}</div>
            </div>
          </div>
        </div>
        
        <div class="map-actions">
          <button class="confirm-btn" @click="confirmMapSearch" :disabled="mapResults.length === 0">
            确认搜索 ({{ mapResults.length }}个结果)
          </button>
        </div>
      </div>
    </div>

    <!-- 发布需求弹窗 -->
    <div v-if="showPublishModalFlag" class="publish-modal" @click.self="closePublishModal">
      <div class="publish-modal-container">
        <div class="publish-modal-header">
          <h3>发布土方信息</h3>
          <button class="close-btn" @click="closePublishModal">×</button>
        </div>
        <div class="publish-modal-content">
          <Publish :val="1" @close="closePublishModal" />
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
/* global AMap */
import TopHeader from './top-Header.vue'
import Publish from './publish.vue'
import Footer from './Footer.vue'
import { getSoilInfoList } from '@/api/user'
export default {
  name: 'FindList',
  components: {
    TopHeader,
    Publish,
    Footer
  },
  data() {
    return {
      searchKeyword: '',
      selectedFilter: 'newest',
      selectedType: '',
      selectedRegion: '',
      selectedMore: '',
      // 控制下拉显示
      showFilterDropdown: false,
      showTypeDropdown: false,
      showRegionDropdown: false,
      showMoreDropdown: false,
      // 筛选选项数据
      filterOptions: [
        { label: '最新上架', value: 'newest' },
        { label: '离我最近', value: 'area' },
        { label: '体积', value: 'volume' },
      ],
      typeOptions: [
        { label: '表土', value: 'tableSoil' },
        { label: '松软土', value: 'softSoil' },
        { label: '普通土', value: 'commonSoil' },
        { label: '坚土', value: 'hardSoil' },
        { label: '砂砾坚土', value: 'gravelHardSoil' },
        { label: '软石', value: 'softStone' },
        { label: '次坚石', value: 'softStone' },
        { label: '坚石', value: 'softStone' },
        { label: '特坚石', value: 'hardStone' },
        { label: '回填土', value: 'backfillSoil' },
        { label: '外运土方', value: 'exportEarthwork' },
        { label: '借方土', value: 'borrowSoil' },
        { label: '常规土方', value: 'conventionalEarthwork' },
        { label: '特殊土方', value: 'specialEarthwork' }
      ],
      regionOptions: [
        { label: '全秦皇岛', value: 'qhd' },
        { label: '海港区', value: 'haignag' },
        { label: '开发区', value: 'kaifa' },
        { label: '抚宁区', value: 'funing' },
        { label: '山海关区', value: 'shanhaiguan' },
        { label: '北戴河区', value: 'beidaihe' },
        { label: '北戴河新区', value: 'beidaihexinqu' },
        { label: '青龙县', value: 'qinglong' },
        { label: '昌黎县', value: 'changli' },       
        { label: '卢龙县', value: 'lulong' },        
       
      ],
      moreOptions: [
        { label: '体积排序', value: 'area' },
        { label: '最新发布', value: 'latest' }
      ],
      showMap: false,
      showPublishModalFlag: false,
      mapLocation: '',
      selectedDistance: '5',
      mapResults: [],
      map: null,
      clickMarker: null,
      mapCenter: { lng: 119.6, lat: 39.9 },
      searchCircle: null, // 搜索范围圆圈
      landList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  mounted() {
    // 从路由查询参数获取搜索关键词
    const keyword = this.$route.query.keyword
    if (keyword) {
      this.searchKeyword = keyword
      // 根据关键词自动填充土方类型
      this.autoFillTypeByKeyword(keyword)
    }
    // 拉取列表（找土：infoType=1）
    this.fetchList();
    // 动态加载高德地图API
    this.loadAmapScript();
    // 添加点击外部关闭下拉框的事件监听
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // 清理地图实例
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    async fetchList() {
      try {
        const res = await getSoilInfoList({ pageNum: this.pageNum, pageSize: this.pageSize, infoType: 0 });
        const list = (res && res.rows) || res?.data || [];
        this.landList = (list || []).map(item => {
          // 从fileName拼接完整路径
          const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
          const firstFileName = typeof item.imageUrl === 'string' ? (item.imageUrl.split(',').find(u => u && u.trim()) || '') : '';
          const firstImg = firstFileName ? (firstFileName.startsWith('http') ? firstFileName : imageBaseUrl + firstFileName) : '';
          return {
            image: firstImg || require('@/assets/sjt/1.png'),
            title: item.title || '未命名',
            tags: [item.soilType || '土方', item.region || ''],
            description: `${item.volume || 0}${item.volumeUnit || ''}`,
            isVideo: false,
            id: item.id,
            region: item.region || ''
          };
        });
        // 设置总数
        this.total = res?.total || res?.data?.total || this.landList.length;
      } catch (e) {
        console.error('获取找土列表失败:', e);
        this.landList = [];
        this.total = 0;
      }
    },
    handleClickOutside(event) {
      // 如果点击的不是下拉框相关元素，则关闭所有下拉框
      if (!event.target.closest('.filter-select-wrapper')) {
        this.hideAllDropdowns();
      }
    },
    performSearch() {
      console.log('搜索关键词:', this.searchKeyword);
      this.pageNum = 1; // 重置到第一页
      this.fetchList();
    },
    prevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.fetchList();
        // 滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    nextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum++;
        this.fetchList();
        // 滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    toggleDropdown(type) {
      // 先关闭所有下拉框
      this.showFilterDropdown = false;
      this.showTypeDropdown = false;
      this.showRegionDropdown = false;
      this.showMoreDropdown = false;
      
      // 然后切换指定的下拉框
      switch(type) {
        case 'filter':
          this.showFilterDropdown = !this.showFilterDropdown;
          break;
        case 'type':
          this.showTypeDropdown = !this.showTypeDropdown;
          break;
        case 'region':
          this.showRegionDropdown = !this.showRegionDropdown;
          break;
        case 'more':
          this.showMoreDropdown = !this.showMoreDropdown;
          break;
      }
    },
    hideDropdown(type) {
      switch(type) {
        case 'filter':
          this.showFilterDropdown = false;
          break;
        case 'type':
          this.showTypeDropdown = false;
          break;
        case 'region':
          this.showRegionDropdown = false;
          break;
        case 'more':
          this.showMoreDropdown = false;
          break;
      }
    },
    showDropdown(type) {
      // 先关闭所有下拉框
      this.showFilterDropdown = false;
      this.showTypeDropdown = false;
      this.showRegionDropdown = false;
      this.showMoreDropdown = false;
      
      // 然后打开指定的下拉框
      switch(type) {
        case 'filter':
          this.showFilterDropdown = true;
          break;
        case 'type':
          this.showTypeDropdown = true;
          break;
        case 'region':
          this.showRegionDropdown = true;
          break;
        case 'more':
          this.showMoreDropdown = true;
          break;
      }
    },
    hideAllDropdowns() {
      this.showFilterDropdown = false;
      this.showTypeDropdown = false;
      this.showRegionDropdown = false;
      this.showMoreDropdown = false;
    },
    handleFilterChange(value) {
      this.selectedFilter = value;
      this.hideAllDropdowns();
      this.pageNum = 1; // 重置到第一页
      this.performSearch();
    },
    // 根据关键词自动填充土方类型
    autoFillTypeByKeyword(keyword) {
      if (!keyword) return
      
      // 关键词到类型的映射
      const keywordToTypeMap = {
        '松软土': 'softSoil',
        '普通土': 'commonSoil',
        '表土': 'tableSoil',
        '坚土': 'hardSoil',
        '回填土方': 'backfillSoil',
        '回填土': 'backfillSoil',
        '砂砾坚土': 'gravelHardSoil',
        '软石': 'softStone',
        '次坚石': 'softStone',
        '坚石': 'softStone',
        '特坚石': 'hardStone',
        '外运土方': 'exportEarthwork',
        '借方土': 'borrowSoil',
        '常规土方': 'conventionalEarthwork',
        '特殊土方': 'specialEarthwork'
      }
      
      // 查找匹配的类型
      const matchedType = keywordToTypeMap[keyword]
      if (matchedType) {
        this.selectedType = matchedType
      }
    },
    
    handleTypeChange(value) {
      this.selectedType = value;
      this.hideAllDropdowns();
      this.pageNum = 1; // 重置到第一页
      this.performSearch();
    },
    handleRegionChange(value) {
      this.selectedRegion = value;
      this.hideAllDropdowns();
      this.pageNum = 1; // 重置到第一页
      this.performSearch();
    },
    handleMoreChange(value) {
      this.selectedMore = value;
      this.hideAllDropdowns();
      this.performSearch();
    },
    getFilterLabel(value) {
      const filter = this.filterOptions.find(f => f.value === value);
      return filter ? filter.label : '请选择';
    },
    getTypeLabel(value) {
      if (!value) return '全部';
      const type = this.typeOptions.find(t => t.value === value);
      return type ? type.label : '全部';
    },
    getRegionLabel(value) {
      if (!value) return '全部';
      const region = this.regionOptions.find(r => r.value === value);
      return region ? region.label : '全部';
    },
    getMoreLabel(value) {
      if (!value) return '全部';
      const more = this.moreOptions.find(m => m.value === value);
      return more ? more.label : '全部';
    },
    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve();
      }
      
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://webapi.amap.com/maps?v=2.0&key=6c995fc229d0e1ad8fa3f066161ee70a';
        script.onload = () => {
          console.log('高德地图API加载完成');
          // 加载所有需要的插件
          AMap.plugin(['AMap.Geolocation', 'AMap.Scale', 'AMap.ToolBar'], () => {
            console.log('所有插件加载完成');
            resolve();
          });
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async showMapModal() {
      this.showMap = true;
      try {
        await this.loadAmapScript();
        this.$nextTick(() => {
          this.initAmap();
        });
        this.generateMapResults();
      } catch (error) {
        console.error('地图加载失败:', error);
      }
    },
    initAmap() {
      if (!window.AMap) {
        console.error('高德地图API未加载');
        return;
      }

      // 根据初始搜索范围设置地图缩放级别
      const initialDistance = parseInt(this.selectedDistance);
      let initialZoom   ;
      
      if (initialDistance <= 5) {
        initialZoom = 11;
      } else if (initialDistance <= 10) {
        initialZoom = 10;
      } else if (initialDistance <= 20) {
        initialZoom = 9;
      } 

      // 初始化地图
      this.map = new AMap.Map('amap-container', {
        zoom: initialZoom,
        center: [119.6, 39.9], // 秦皇岛市中心坐标
        mapStyle: 'amap://styles/normal'
      });

      // 添加点击事件
      this.map.on('click', (e) => {
        this.handleMapClick(e);
      });

      // 添加定位控件
      try {
        // 确保Geolocation插件已加载
        if (AMap.Geolocation) {
          this.map.addControl(new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
            convert: true,
            showButton: true,
            buttonPosition: 'LB',
            showMarker: true,
            showCircle: true,
            panToLocation: true,
            zoomToAccuracy: true
          }));
        } else {
          console.warn('Geolocation插件未加载，尝试延迟加载');
          // 尝试延迟加载定位插件
          AMap.plugin('AMap.Geolocation', () => {
            if (AMap.Geolocation) {
              this.map.addControl(new AMap.Geolocation({
                enableHighAccuracy: true,
                timeout: 10000,
                showButton: true,
                buttonPosition: 'LB'
              }));
            }
          });
        }
      } catch (error) {
        console.error('添加定位控件失败:', error);
        // 如果定位控件加载失败，添加一个简单的定位按钮
        this.addSimpleLocationButton();
      }

      // 添加比例尺控件
      try {
        if (AMap.Scale) {
          this.map.addControl(new AMap.Scale());
        } else {
          console.warn('Scale控件未加载');
        }
      } catch (error) {
        console.error('添加比例尺控件失败:', error);
      }

      // 添加工具条控件
      try {
        if (AMap.ToolBar) {
          this.map.addControl(new AMap.ToolBar());
        } else {
          console.warn('ToolBar控件未加载');
        }
      } catch (error) {
        console.error('添加工具条控件失败:', error);
      }
      
      // 添加初始搜索范围圆圈
      this.updateSearchCircle();
    },
    handleMapClick(e) {
      const { lng, lat } = e.lnglat;
      console.log('地图点击位置:', lng, lat);
      
      // 清除之前的标记
      if (this.clickMarker) {
        this.map.remove(this.clickMarker);
      }
      
      // 添加点击标记
      this.clickMarker = new AMap.Marker({
        position: [lng, lat],
        title: '选择的位置'
      });
      this.map.add(this.clickMarker);
      
      // 更新搜索中心点
      this.mapCenter = { lng, lat };
      
      // 更新搜索范围圆圈
      this.updateSearchCircle();
      
      // 重新生成搜索结果
      this.generateMapResults();
    },
    closeMapModal() {
      this.showMap = false;
      this.mapResults = [];
      
      // 清理地图实例
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },
    showPublishModal() {
      this.showPublishModalFlag = true;
    },
    closePublishModal() {
      this.showPublishModalFlag = false;
    },
    searchLocation() {
      if (this.mapLocation.trim()) {
        console.log('搜索位置:', this.mapLocation);
        this.generateMapResults();
      }
    },
    updateMapRadius() {
      console.log('更新搜索范围:', this.selectedDistance + '公里');
      this.generateMapResults();
      
      // 根据搜索范围调整地图缩放级别
      if (this.map) {
        const distance = parseInt(this.selectedDistance);
        let zoomLevel;
        // 5,11 10,10 20,9
        if (distance <= 5) {
          zoomLevel = 11;
        } else if (distance <= 10) {
          zoomLevel = 10;
        } else if (distance <= 20) {
          zoomLevel = 9;
        } 
        
        this.map.setZoom(zoomLevel);
        console.log('地图缩放级别调整为:', zoomLevel);
        
        // 更新搜索范围圆圈
        this.updateSearchCircle();
      }
    },
    // 简单的定位按钮作为备选方案
    addSimpleLocationButton() {
      if (!this.map) return;
      
      const locationBtn = document.createElement('div');
      locationBtn.className = 'simple-location-btn';
      locationBtn.innerText = '定位';
      locationBtn.style.cssText = `
        position: absolute;
        bottom: 20px;
        left: 20px;
        z-index: 100;
        padding: 8px 16px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      `;
      
      locationBtn.addEventListener('click', () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { longitude, latitude } = position.coords;
              // 设置地图中心点
              this.map.setCenter([longitude, latitude]);
              this.map.setZoom(11);
              
              // 更新搜索中心点
              this.mapCenter = { lng: longitude, lat: latitude };
              
              // 添加标记
              if (this.clickMarker) {
                this.map.remove(this.clickMarker);
              }
              this.clickMarker = new AMap.Marker({
                position: [longitude, latitude],
                title: '我的位置'
              });
              this.map.add(this.clickMarker);
              
              // 更新搜索范围
              this.updateSearchCircle();
              this.generateMapResults();
            },
            (error) => {
              console.error('浏览器定位失败:', error);
              alert('定位失败，请手动选择位置');
            }
          );
        } else {
          alert('您的浏览器不支持定位功能');
        }
      });
      
      const mapContainer = document.getElementById('amap-container');
      if (mapContainer) {
        mapContainer.appendChild(locationBtn);
      }
    },
    updateSearchCircle() {
      if (!this.map || !this.mapCenter) return;
      
      // 清除之前的圆圈
      if (this.searchCircle) {
        this.map.remove(this.searchCircle);
      }
      
      // 创建新的搜索范围圆圈
      const radius = parseInt(this.selectedDistance) * 1000; // 转换为米
      this.searchCircle = new AMap.Circle({
        center: [this.mapCenter.lng, this.mapCenter.lat],
        radius: radius,
        strokeColor: '#0d6a57',
        strokeWeight: 2,
        strokeOpacity: 0.8,
        fillColor: '#0d6a57',
        fillOpacity: 0.1
      });
      
      this.map.add(this.searchCircle);
    },
    generateMapResults() {
      // 模拟土数据（包含真实坐标）
      const landData = [
        {
          title: '秦皇岛抚宁区砂砾土',
          description: '50-80立方/长期/抚宁区',
          price: '抚宁区',
          lng: 119.2,
          lat: 40.0
        },
        {
          title: '秦皇岛卢龙县软土',
          description: '20-30立方/20年/卢龙县',
          price: '卢龙县',
          lng: 118.9,
          lat: 39.8
        },
        {
          title: '秦皇岛开发区坚土',
          description: '15-25立方/30年/开发区',
          price: '开发区',
          lng: 119.5,
          lat: 39.9
        },
        {
          title: '秦皇岛海港区砂砾土',
          description: '10-20立方/70年/海港区',
          price: '海港区',
          lng: 119.6,
          lat: 39.9
        },
        {
          title: '秦皇岛山海关区软土',
          description: '100-200立方/10年/山海关区',
          price: '山海关区',
          lng: 119.8,
          lat: 40.1
        }
      ];
      
      // 计算距离并筛选结果
      this.mapResults = landData.map(land => {
        const distance = this.calculateDistance(
          this.mapCenter.lng, this.mapCenter.lat,
          land.lng, land.lat
        );
        return {
          ...land,
          distance: distance.toFixed(1)
        };
      }).filter(result => 
        parseFloat(result.distance) <= parseInt(this.selectedDistance)
      );
    },
    calculateDistance(lng1, lat1, lng2, lat2) {
      // 使用Haversine公式计算两点间距离（公里）
      const R = 6371; // 地球半径（公里）
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    selectMapResult(result) {
      console.log('选择地图结果:', result);
      // 这里可以添加选择结果后的逻辑
    },
    confirmMapSearch() {
      console.log('确认地图搜索，结果数量:', this.mapResults.length);
      this.closeMapModal();
      // 这里可以添加确认搜索后的逻辑，比如更新主列表
    },
    goToLandDetail(index) {
      console.log('查看土详情:', index);
      let productId = index;
      this.$router.push({ path: `/product/${productId}`, query: { from: 'search' } });
    }
  }
}
</script>

<style scoped>
@import url('../assets/iconfont.css');

.land-supply-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 40px 0;
  background: linear-gradient(135deg, #FF6B35 0%, #FF8C00 100%);
  border-radius: 12px;
  color: white;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 15px 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.page-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* 搜索栏 */
.search-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  padding: 20px;
}

.search-bar {
  display: flex;
  gap: 15px;
  align-items: center;
}

.search-input {
  flex: 1;
  height: 45px;
  padding: 0 20px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  border-color: #422C27;
}

.search-btn {
  height: 45px;
  padding: 0 25px;
  background: #381E1D;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.search-btn:hover {
  background: #E4CEC2;
}

.map-btn {
  height: 45px;
  padding: 0 25px;
  background: white;
  color: #422C27;
  border: #422C27 solid 1px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.map-btn:hover {
  background: #E4CEC2;
  color: #333;
  border: #E4CEC2 solid 1px;
}

/* 筛选栏 */
.filter-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  padding: 15px 20px;
}

/* 横向筛选组样式 */
.horizontal-filter-group {
  width: 100%;
  background: white;
  border-radius: 4px;
}

/* 筛选标签行 - 横向排列 */
.filter-labels-row {
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 10px 0;
  flex-wrap: wrap;
}

/* 筛选选择组 */
.filter-select-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-select-label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  font-weight: 400;
}

.filter-select-wrapper {
  position: relative;
}

.filter-select-input {
  width: 180px;
  height: 40px;
  padding: 0 35px 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background: white;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.filter-select-input:hover {
  border-color: #999;
}

.filter-select-wrapper:focus-within .filter-select-input {
  border-color: #422C27;
  box-shadow: 0 0 0 2px rgba(66, 44, 39, 0.1);
}

.filter-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.filter-arrow {
  font-size: 12px;
  color: #999;
  transition: transform 0.3s ease;
  margin-left: 8px;
  position: absolute;
  right: 10px;
}

.filter-select-wrapper:focus-within .filter-arrow {
  transform: rotate(180deg);
}

/* 下拉选项框 - 显示在输入框下方 */
.filter-dropdown {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 100;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  margin-top: 2px;
  min-width: 100%;
  max-width: 400px;
  width: 300px;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
}

.filter-option {
  display: inline-block;
  padding: 6px 18px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.filter-option:hover {
  color: #333;
  background: #E4CEC2;
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(14, 133, 117, 0.2);
}

.filter-option.active {
  border-color: #422C27;
  background: #422C27;
  color: white;
  font-weight: 500;
}

/* 土列表 */
.land-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.land-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;
  display: flex;
  border: 2px solid transparent;
}

.land-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border: 2px solid #422C27;
}

.land-image {
  position: relative;
  width: 300px;
  height: 200px;
  flex-shrink: 0;
}

.land-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.guarantee-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #FF6B35;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.watermark {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 500;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.land-details {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
}

.land-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.land-tags {
  margin-bottom: 15px;
}

.tag {
  display: inline-block;
  padding: 4px 12px;
  background: #E3F2FD;
  color: #1976D2;
  border: 1px solid #BBDEFB;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
  margin-bottom: 5px;
}

.land-description {
  font-size: 14px;
  color: #666;
  margin: 0 0 15px 0;
  line-height: 1.5;
}

.land-price {
  font-size: 20px;
  font-weight: bold;
  color: #FF6B35;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .land-item {
    flex-direction: column;
  }

  .land-image {
    width: 100%;
    height: 200px;
  }

  .search-bar {
    flex-direction: column;
    gap: 10px;
  }

  .search-input {
    width: 100%;
  }

  .search-btn,
  .map-btn {
    width: 100%;
  }

  .filter-labels-row {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .filter-select-group {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .filter-select-input {
    width: 100%;
  }

  .filter-dropdown {
    max-width: 100%;
  }
}

/* 地图模态框样式 */
.map-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.map-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background: #eee;
}

.map-controls {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.location-input {
  flex: 1;
  display: flex;
  gap: 10px;
  min-width: 300px;
}

.location-search {
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.location-search:focus {
  border-color: #FF6B35;
}

.search-location-btn {
  height: 40px;
  padding: 0 20px;
  background: #FF6B35;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.search-location-btn:hover {
  background: #FF8C00;
}

.distance-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.distance-selector label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

.distance-selector select {
  height: 40px;
  padding: 0 30px 0 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath fill='%23422C27' d='M7 11L2 6h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 12px;
}

.map-content {
  height: 400px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.amap-container {
  width: 100%;
  height: 100%;
}

.map-placeholder {
  text-align: center;
  color: #666;
}

.map-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.map-tip {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.map-results {
  max-height: 200px;
  overflow-y: auto;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.map-results h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.result-item:hover {
  background: #e9ecef;
}

.result-info h5 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #333;
}

.result-info p {
  margin: 0 0 5px 0;
  font-size: 12px;
  color: #666;
}

.distance {
  font-size: 12px;
  color: #FF6B35;
  font-weight: 500;
}

.result-price {
  font-size: 16px;
  font-weight: bold;
  color: #FF6B35;
}

.map-actions {
  padding: 20px;
  text-align: center;
}

.confirm-btn {
  background: #FF6B35;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirm-btn:hover:not(:disabled) {
  background: #FF8C00;
}

.confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .map-container {
    width: 95%;
    margin: 10px;
  }
  
  .map-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .location-input {
    min-width: auto;
  }
  
  .distance-selector {
    justify-content: space-between;
  }
}
  .result-info{
  text-align: left;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:hover:not(:disabled) {
  background: #422C27;
  color: white;
  border-color: #422C27;
}

.page-info {
  font-size: 14px;
  color: #666;
}

/* 发布需求弹窗样式 */
.publish-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
}

.publish-modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 95vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.publish-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  flex-shrink: 0;
}

.publish-modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.publish-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.publish-modal-content .land-supply-page {
  margin: 0;
  padding: 20px;
  background: white;
}

.publish-modal-content .container {
  padding: 0;
}

.publish-modal-content .form-wrapper {
  margin: 0;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .publish-modal {
    padding: 10px;
  }

  .publish-modal-container {
    width: 95%;
    max-height: 98vh;
  }

  .publish-modal-content {
    padding: 10px;
  }
}
</style>


